export enum UserNotificationEntityType {
  BuyingSessionProduct = 'VIPEntityType:VIPBuyingSessionProduct',
  OrderProduct = 'VIPEntityType:VIPOrderProduct',
  BuyingSessionGroup = 'VIPEntityType:VIPBuyingSessionGroup',
  ClientOrder = 'VIPEntityType:VIPClientOrder'
}

export enum UserNotificationProducts {
  BuyingSessionProduct = 'buyingSessionProduct',
  BuyingSessionGroup = 'buyingSessionGroup',
  OrderProduct = 'orderProduct',
  ClientOrder = 'clientOrder'
}
